const PfmBarChart = require('okCharts/pfmBarChart/pfmBarChart');

module.exports = PfmBarChart;
